import { useCurrentUser } from "api/services/useCurrentUser";
import { useOnboardings } from "api/services/useOnboardings";
import { useAppDispatch } from "hooks/store";
import { setAuthUser } from "store/slices/Auth/authSlice";
import { setDismissedOnboardings } from "store/slices/Onboardings/onboardingsSlice";

export function useResetOnboardings() {
  const { refetch: refetchUser } = useCurrentUser();
  const { resetOnboardingsAsync } = useOnboardings();
  const dispatch = useAppDispatch();

  const performOnboardingsReset = async () => {
    dispatch(
      setDismissedOnboardings({
        detectorDetail: false,
        detectorManagement: false,
        queryDetail: false,
      })
    );

    await resetOnboardingsAsync();

    // refetch user since user_profile is a nested field so when the onboarding
    // fields are reset we need to update our local state of user
    const user = await refetchUser();
    dispatch(setAuthUser(user));
  };

  return performOnboardingsReset;
}
